module.exports = __webpack_public_path__ + "media/components/country-flag/static/ru-bcbda8196c499923ad774ace9618ec52.svg";